// extracted by css-extract-rspack-plugin
export default {"PageHeader":"DGF6J","Decoy":"DeKdJ","PageBody":"VDDdn"};